export const deliveryFreeThreshold = 5_000;
